import { Variants } from 'framer-motion'
import { useEffect, useState } from 'react'

import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit'
import { UnitEventsHistory } from '@apps-common/apps/portal/pages/units/pages/manage/pages/events/components/UnitEventsHistory'
import { HubConnectionStatus } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { useSignalR } from '@apps-common/contexts/SignalrContext'
import { ROUTE_UNIT_EVENTS } from '@apps-radionet-portal/config/private-routes'

export const unitZonesChildVariants: Variants = {
  initial: {
    opacity: 0,
    position: 'relative',
    left: '50px',
    transition: {
      duration: 0.25
    }
  },
  animate: {
    opacity: 1,
    position: 'relative',
    left: 0,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    position: 'relative',
    left: '50px',
    transition: {
      duration: 0.15
    }
  }
}

interface IProps {
  status: string
  unitId: string
}

export const UnitEventsView: React.FC<IProps> = ({ status, unitId }) => {
  const { status: cs, setIdentifier } = useSignalR()
  const { data: unit, isLoading: unitIsLoading, isError: unitIsError, refetch } = useGetUnitGenericDetails({ status, unitId })
  const [top, setTop] = useState<number>(0)

  const { accountNo } = unit || {}
  const isAtTop = top <= 50

  useEffect(() => {
    if (unit) {
      setIdentifier(unit)
    }
  }, [unit])

  return (
    <>
      <Header classes='!max-w-[1100px] pb-[10px]'>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_UNIT_EVENTS} />
        <div className='flex items-center justify-between w-full mt-[10px]'>
          <PageTitle>Events</PageTitle>
          <div>
            <HubConnectionStatus hubStatus={cs} />
          </div>
        </div>
      </Header>
      <LayoutContainer onScroll={setTop}>
        <UnitEventsHistory isAtTop={isAtTop} unit={unit} />
      </LayoutContainer>
    </>
  )
}
